export const nl = {
  returnLineItems: {
    refund: "Terugbetaling(en)",
    exchange: "Ruil(en)",
    discount: "Korting(en)",
  },
  returnStoreAddress: {
    mapButton: "Bekijk op kaart",
  },
  downloadLabel: {
    label: "Mijn label downloaden",
    bonDeRetour: "Mijn retourformulier downloaden",
  },
  returnRequestDate: {
    label: "Je retouraanvraag is gedaan op {{date}} om {{time}}",
  },
  actions: {
    continue: "Doorgaan",
  },
  "order-identification": {
    title: "Volg uw bestelling",
    description: "Voer uw bestelgegevens in om uw pakket te volgen",
    fields: {
      "zip-code": {
        title: "Postcode",
        description: "Voer uw bezorgpostcode in",
        required: "Postcode is verplicht",
      },
      email: {
        title: "E-mailadres",
        description: "Voer het e-mailadres in dat u voor uw bestelling heeft gebruikt",
        required: "E-mailadres is vereist",
      },
      both: {
        title: "Postcode of e-mail",
        description: "Voer uw bezorgpostcode in of het e-mailadres dat u voor uw bestelling heeft gebruikt",
        required: "Postcode of e-mail is vereist",
      },
      "tracking-number": {
        title: "Bestelnummer",
        description: "Voer uw bestelnummer in",
        required: "Bestelnummer is verplicht",
      },
    },
    errors: {
      "unknown-order": {
        title: "Onbekend bestelnummer",
        description: "Het bestelnummer is niet gevonden, controleer het",
      },
      "search-error": {
        title: "Zoekfout",
        description:
          "We konden de bestelling niet vinden. Probeer het later opnieuw.",
      },
    },
  },
  delivery: "Levering",
  "parcel-history": "Pakketgeschiedenis",
  "order-details": {
    title: "Bestelgegevens",
    "tracking-number": "Trackingnummer",
    "order-number": "Bestelnummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Geschatte leverdatum",
      deliveredOn: "Afgeleverd op",
      from: "van",
      to: "tot",
    },
  },
  deliveryAddress: {
    title: "Bezorgadres:",
    titlePickup: "Adres van afhaalpunt:",
    orderDetails: {
      title: "Bestelgegevens:",
      trackingNumber: "Trackingnummer:",
      orderNumber: "Bestelnummer:",
      orderDate: "Besteldatum:",
    },
  },
  pickupPoint: {
    title: "Afhaalpunt",
    openingHours: "Openingstijden:",
    closed: "Gesloten",
    directions: "Routebeschrijving",
    days: {
      monday: "Maandag:",
      tuesday: "Dinsdag:",
      wednesday: "Woensdag:",
      thursday: "Donderdag:",
      friday: "Vrijdag:",
      saturday: "Zaterdag:",
      sunday: "Zondag:",
    },
  },
  wallet: {
    warningNotEnabled: "U moet Wallet inschakelen in uw winkelinstellingen",
  },
  crossSell: {
    youMightAlsoLike: "Misschien vind je dit ook leuk",
  },
  "rate-order": {
    "order-recap": {
      title: "Jouw bestelling",
      "tracking-label": "Trackingnummer:",
      "order-label": "Bestelnummer:",
    },
    form: {
      title: "Beoordeel je bezorging",
      "rating-label": "Beoordeel je bezorgervaring",
      "comment-label": "Opmerking (optioneel)",
      "comment-placeholder": "Deel je ervaring met ons…",
      "submit-cta": "Mijn beoordeling verzenden",
      "update-cta": "Mijn beoordeling bijwerken",
      "rating-required": "Selecteer een beoordeling.",
    },
    "thank-you": {
      title: "Bedankt voor je feedback!",
      description:
        "Je beoordeling is opgeslagen. Het helpt ons de bezorgervaring te verbeteren.",
    },
    errors: {
      "invalid-token": {
        title: "Ongeldige of verlopen link",
        description:
          "Deze link is niet meer geldig. Open hem opnieuw vanuit je laatste trackingmail.",
      },
      submit: {
        title: "Er is iets misgegaan",
        description:
          "We konden je beoordeling niet opslaan. Probeer het later opnieuw.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Colissimo-afhaalpunt.",
    chronoShop2Shop: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Chronopost-afhaalpunt.",
    ups: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde UPS-afhaalpunt.",
    customerCarrier: "Je kunt je retourpakket nu versturen met de vervoerder van je keuze.",
    merchantCarrier: "We sturen je binnen 1 tot 3 werkdagen een retourlabel per e-mail.",
    returnToStore: "Je kunt je pakket nu afgeven in de dichtstbijzijnde winkel.",
    malca: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde Malca-afhaalpunt.",
    tnt: "Je kunt nu je retourlabel afdrukken en je pakket afgeven bij het dichtstbijzijnde TNT-afhaalpunt.",
    bonDeRetour: "Je retourbon is klaar. Je kunt deze nu afdrukken en gebruiken voor je retour.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Je verzendlabel is klaar",
    bonDeRetour: "Je retourbon is klaar",
  },
} as const;
